<template>
  <div>
    <div class="result-wrapper">
      <div
        v-for="shortcut in shortcuts"
        :key="shortcut.id"
        class="md-primary result-entry"
      >
        <img
          class="bg-image"
          :src="shortcut.images.bgImgUrl ? shortcut.images.bgImgUrl : noImagePlaceholder"
          alt=""
        >

        <div class="bot-line">
          <img
            :src="shortcut.images.iconImgUrl"
            alt=""
          >

          <span>Layout style: {{ shortcut.layout_style }}</span>

          <md-icon
            class="gen-key"
            @click.native="onInfoClick(shortcut)"
          >
            info
          </md-icon>
        </div>

        <h3 class="md-title">
          {{ shortcut.title.en }}
        </h3>
        <a :href="'/shortcut/edit/' + shortcut.id">{{ shortcut.id }}</a>

        <md-chip
          v-for="tag in shortcut.tags"
          :key="tag"
          class="md-primary"
          md-static
        >
          {{ tag }}
        </md-chip>

        <div class="benefit-wrapper">
          <h4 class="h5">
            Benefits
          </h4>
          <div
            v-for="b in shortcut.benefits"
            :key="b.title.en"
            class="benefit-item"
          >
            <img
              :src="b.imageUrl"
              alt=""
            >
            <span class="benefit-title">{{ b.title.en }}</span>
            <span>{{ b.platform }}</span>
          </div>
        </div>

        <div class="benefit-wrapper">
          <h4 class="h5">
            Actions
          </h4>
          <div
            v-for="a in shortcut.actions"
            :key="a.title.en"
            class="benefit-item"
          >
            <img
              :src="a.imageUrl"
              alt=""
            >
            <span>{{ a.title.en }}</span>
            <span>{{ a.platform }}</span>
          </div>
        </div>

        <div class="benefit-wrapper">
          <h4
            class="h5 nodes-title"
            @click="openNodeTable(shortcut)"
          >
            Nodes
          </h4>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="nodesDialog.isOpen">
      <md-dialog-title>Nodes</md-dialog-title>
      <md-dialog-content>
        <md-table>
          <md-table-row
            v-for="node in nodesDialog.nodes"
            :key="node.id"
          >
            <md-table-cell>{{ node.protocol }}</md-table-cell>
            <md-table-cell>{{ node.ip }}</md-table-cell>
            <md-table-cell>{{ node.server_address }}</md-table-cell>
            <md-table-cell>{{ node.location.countryCode }}</md-table-cell>
            <md-table-cell>
              <a
                :href="'/node/edit/' + node.id"
                target="_blank"
              >
                <md-icon class="gen-key">create</md-icon>
              </a>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import noImagePlaceholder from "@/assets/img/no-image.png";

export default {
    props: {
      shortcuts: { type: Array, default: () => [] }
    },
    data(){
        return {
            noImagePlaceholder,
            unfoldedNodeLists: [],

            nodesDialog: {
                isOpen: false,
                nodes: [],
            },
        };
    },
    methods: {
        onInfoClick(shortcut) {
            this.$emit("onInfoClick", shortcut);
        },
        openNodeTable(shortcut) {
            this.nodesDialog = {
                isOpen: true,
                nodes: shortcut.nodes,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.result-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, 350px);
  grid-column-gap: 15px;
  grid-row-gap: 20px;
  justify-items: stretch;
  justify-content: center;
}

.result-entry {
  flex-direction: column;
  color: white;
  min-width: 350px;
  background: linear-gradient(170.85deg, #DB6282 3.42%, #B970BF 35.02%, #607FD0 100%);
  padding: 20px;
  margin: 0 5px 30px 0;

  .bot-line {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    vertical-align: center;

    img {
      width: 40px;
      height: 40px;
    }

    span {
      line-height: 40px;
    }

    i {
      margin: auto 0;
    }
  }

  .bg-image {
    width: 310px;
    height: 170px;
    object-fit: cover;
    border-radius: 12px;
  }

  a {
    color: white !important;
    text-decoration: underline;
  }

  .gen-key {
    color: white;
    cursor: pointer;
  }

  .benefit-wrapper {
      max-width: 310px;
      margin-top: 20px;
      .benefit-item {
          background: transparent;
          display: flex;
          justify-content: space-between;
          align-items: center;

          * {
            display: block;
          }

          img {
            width: 15px;
            height: 15px;
          }

          .benefit-title {
            padding: 0 8px;
          }
      }

      .benefit-item + .benefit-item {
        margin-top: 8px;
      }
  }

  .nodes-title {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
